import { createContext, useContext } from "react";

export const PopupCtx = createContext(null);
export function usePopup() { return useContext(PopupCtx); }
